import React, { useState } from 'react';
import styles from "./Templatepage.module.css";
import { Link, useNavigate } from 'react-router-dom';
import CustomModal from '../Dashboardcomponents/Modal';
import TemplateModal from './TemplateModal';


const Templatepage2 = ({ list }) => {
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState([]);
    const navigate = useNavigate();

    const addTemplate = () => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/loginnew/signin");
        } else {
            console.log("Token available, proceed to use template");
        }
    };

    const handleModal = (item) => {
        setShowModal(true);
        setCurrentItem(item);
    }

    return (
        <>
            <section class={styles.breadcrumb}>
                <div class={styles.container}>
                    <nav class={styles.breadcrumb_nav}>
                        <Link to={"/templates"}>Categories</Link>
                        <span>/</span>
                        <span class={styles.current}>{`${list?.title} templates`}</span>
                    </nav>
                </div>
            </section>

            <section class={styles.category_hero}>
                <div class={styles.container}>
                    <div class={styles.category_header}>
                        <div class={styles.category_icon_large}>📊</div>
                        <h1>{`${list?.title} templates`}</h1>
                        <p>{`Professional Templates with analytics, charts, and comprehensive UI components designed for modern web applications.`}</p>
                        <div class={styles.category_meta}>
                            <span>⭐{`${list?.list?.[0]?.length || 0} templates`}</span>
                            {/* <span>•</span>
                                <span>Updated Weekly</span>
                                <span>•</span>
                                <span>⭐ Popular Category</span> */}
                        </div>
                    </div>
                </div>
            </section>
            <section class={styles.templates}>
                <div class={styles.container}>
                    {
                        list?.list?.[0]?.length > 0 ?
                            <div class={styles.templates_grid}>
                                {
                                    list?.list?.[0]?.map((items, i) => (
                                        <div key={i} class={styles.template_card}>
                                            <div onClick={() => handleModal(items)} class={styles.template_image}>
                                                <img
                                                    src={`data:image/jpeg;base64,${items.previews[0]}`}
                                                    alt={items.title || "Template Preview"}
                                                />
                                                <div class={styles.template_overlay}>
                                                    <button class={styles.preview_btn}>👁️ More Details</button>
                                                </div>
                                            </div>
                                            <div class={styles.template_content}>
                                                <div class={styles.template_header}>
                                                    <h3>{items.title}</h3>
                                                    <div class={styles.template_rating}>
                                                        {/* <span>⭐ 4.9</span> */}
                                                    </div>
                                                </div>
                                                <p>{items.description}</p>
                                                <div class={styles.template_footer}>
                                                    {/* <span class={styles.downloads}>2.1k downloads</span> */}
                                                    <button onClick={addTemplate} class={styles.use_template_btn}>Use Template</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div> : <div style={{ display: "flex" }}>
                                <p style={{ margin: "auto auto", }}>No templates available in this category</p>
                            </div>
                    }
                </div>
                {
                    <CustomModal show={showModal}>
                        <TemplateModal setShowModal={setShowModal} currentItem={currentItem} />
                    </CustomModal>
                }
            </section>
        </>
    )
}

export default Templatepage2